// extracted by mini-css-extract-plugin
module.exports = {"container":"_1MggeiVFlh-5C_4I9fuIxq"};